import { useCommentsCount, useHierarchicalComments } from "./hooks";
import Comment from "./Comment";
import { QueryKeysConfig } from "@/config/query-keys";
import cls from "./styles.module.css";
import { usePostCommentsLoader } from "@/hooks/network/use-post-comments-loader";
import { useSuspenseQuery } from "@tanstack/react-query";
import type { TRespondTarget } from "../CommentForm/typings";
import { withSuspenseBoundary } from "@/components/withSuspenseBoundary";
import Skeleton from "react-loading-skeleton";
import { withQueryErrorResetBoundary } from "@/components/ErrorBoundary/withQueryErrorResetBoundary";

type TProps = {
  postId: number;
  changeRespondTarget: (target: TRespondTarget) => any;
};
function CommentsList({ postId, changeRespondTarget }: TProps) {
  const getComments = usePostCommentsLoader();
  const { data } = useSuspenseQuery({
    queryKey: [QueryKeysConfig.postComments, postId],
    queryFn: () => getComments({ data: { postId } }),
  });
  const comments = useHierarchicalComments(data.comments);
  const count = useCommentsCount(data.comments);
  return (
    <div className={cls.root}>
      <h2 className={cls.count}>{count}</h2>
      <ul>
        {comments.map((comment) => (
          <Comment
            changeRespondTarget={changeRespondTarget}
            key={comment.id}
            comment={comment}
          />
        ))}
      </ul>
    </div>
  );
}
export default withQueryErrorResetBoundary(
  withSuspenseBoundary(CommentsList, <Skeleton count={3} />),
);
